var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrafts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 0.335938C28.7754 0.335938 29.1993 0.511532 29.5118 0.824093C29.8244 1.13665 30 1.56058 30 2.0026V8.26427L15.0017 23.2643L14.9917 30.3276L22.0683 30.3376L30 22.4059V32.0026C30 32.4446 29.8244 32.8686 29.5118 33.1811C29.1993 33.4937 28.7754 33.6693 28.3333 33.6693H1.66667C1.22464 33.6693 0.800716 33.4937 0.488155 33.1811C0.175595 32.8686 0 32.4446 0 32.0026V2.0026C0 1.56058 0.175595 1.13665 0.488155 0.824093C0.800716 0.511532 1.22464 0.335938 1.66667 0.335938H28.3333ZM31.2967 11.6826L33.6533 14.0393L20.69 27.0026L18.33 26.9993L18.3333 24.6459L31.2967 11.6826ZM15 17.0026H6.66667V20.3359H15V17.0026ZM20 10.3359H6.66667V13.6693H20V10.3359Z",
    fill: "#374DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrafts);
export default __webpack_public_path__ + "static/media/drafts.bb78d0add40182c78ebe3a2acf4f8b43.svg";
export { ForwardRef as ReactComponent };